import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import TextField from "@mui/material/TextField";
import Layout from "./layout";
import axios from "axios";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import TableSortLabel from "@mui/material/TableSortLabel";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import Stack from "@mui/material/Stack";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import TableFooter from "@mui/material/TableFooter";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Checkbox from "@mui/material/Checkbox";
import { List, ListItem, ListItemText} from "@mui/material";
import { DialogActions,DialogContentText } from '@mui/material';
import {Delete as DeleteIcon } from "@mui/icons-material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ListAltIcon from "@mui/icons-material/ListAlt";
import { useAcademicYear } from "./AcademicYearContext";
import Divider from "@mui/material/Divider";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import kitAddIcon from "../images/kitAdd.png";
import kitEditIcon from "../images/kitEdit.png";


export default function Kits() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchQuery, setSearchQuery] = useState("");
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  
  
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("kit_id");
  const [isAddCategoryModal, setisAddCategoryModal] = useState(false);

  const [userId, setUserId] = useState();
  const [searchResults, setSearchResults] = useState([]);

  const [kitId, setKitId] = useState();
  const [kits, setKits] = useState([]);

  const [kitName, setKitName] = useState();
  const [kitNameError, setKitNameError] = useState();
  const [selectProductError, setSelectProductError] = useState();
  const [description, setDescription] = useState("");
  const [quantity, setQuantity] = useState(0);
  const [quantityError, setQuantityError] = useState();
  
  const [quantityValidation, setQuantityValidation] = useState({});


  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarMessageColor, setSnackbarMessageColor] = useState("");
  const [showSnackbarMessage, setShowSnackbarMessage] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [kitProducts, setKitProducts] = useState([{}]);
  const [open, setOpen] = useState(false);
  const [selectedKit, setSelectedKit] = useState([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedNameToReplicate, setSelectedNameToReplicate] = useState('');
  const [selectedDescriptionToReplicate, setSelectedDescriptionToReplicate] = useState('');
  const [selectedQuantityToReplicate, setSelectedQuantityToReplicate] = useState('');
  const [selectedTotalPrice, setSelectedTotalPrice] = useState('');
  const [openBarcodeDialog, setOpenBarcodeDialog] = useState(false);
   const { academicYearId } = useAcademicYear();
  const [selectedQuantities, setSelectedQuantities] = useState({});
  const [openDelete, setOpenDelete] = useState(false);
  const [deletedRows, setDeletedRows] = useState([]); // Stores product IDs marked for delete
  const [sortOrder, setSortOrder] = useState("desc"); // Sorting order: 'asc' or 'desc'
  const [sortColumn, setSortColumn] = useState("sl_no"); // Column to sort by
  const [isReplicating, setIsReplicating] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
   const [isLoading, setIsLoading] = useState(false);

   
  const getSerialNumber = (index) => page * rowsPerPage + index + 1;
  const handleDeleteProduct = () => {
    setOpenDelete(true);
  };
  const handleToggleDelete = (productId, quantity) => {
    setDeletedRows((prev) =>
      prev.some((item) => item.product_id === productId)
        ? prev.filter((item) => item.product_id !== productId) // Remove if already marked
        : [...prev, { product_id: productId, quantity }] // Add with quantity
    );
  };
  const handleDeleteConfirm = async () => {
    setConfirmDelete(true);
    setSelectedProducts((prevProducts) =>
      prevProducts.filter(
        (p) => !deletedRows.some((item) => item.product_id === p.product_id)
      )
    );
  
   
  
    setDeletedRows([]); // Clear marked rows
    setOpenDelete(false);
  };
  const handleCancelDelete = () => {
    setDeletedRows([]); // Remove red lines (undo delete)
    setOpenDelete(false);
  };
      
    
      useEffect(() => {
        console.log("Received Academic Year ID:", academicYearId);
      }, [academicYearId]);

      // Sorting function
      // const handleSort = (property) => {
      //   const isAsc = sortColumn === property && sortOrder === "asc";
      //   setSortOrder(isAsc ? "desc" : "asc");
      //   setSortColumn(property);
      // };
      const handleSort = (property) => {
        let newOrder = sortOrder === "asc" ? "desc" : "asc";
      
        // If sorting "sl_no", reverse the entire data array
        if (property === "sl_no") {
          setSelectedProducts([...selectedProducts.reverse()]); // Reverse order of data array
        } else {
          // Apply normal sorting logic for other columns
          const isAsc = sortColumn === property && sortOrder === "asc";
          newOrder = isAsc ? "desc" : "asc";
          setSelectedProducts([...selectedProducts].sort((a, b) => 
            isAsc ? a[property] - b[property] : b[property] - a[property]
          ));
        }
      
        setSortOrder(newOrder);
        setSortColumn(property);
      };
      // Sort the `selectedProducts` array based on sortColumn and sortOrder
      const sortedProducts = [...selectedProducts].sort((a, b) => {
        let valueA, valueB;
      
        if (sortColumn === "price" || sortColumn === "quantity") {
          valueA = parseFloat(a[sortColumn].toString().replace(/[₹,]/g, ""));
          valueB = parseFloat(b[sortColumn].toString().replace(/[₹,]/g, ""));
        } else if (sortColumn === "total_price") {
          // Calculate total price dynamically
          valueA = parseFloat(a.price.replace(/[₹,]/g, "")) * a.quantity;
          valueB = parseFloat(b.price.replace(/[₹,]/g, "")) * b.quantity;
        } else {
          valueA = a[sortColumn];
          valueB = b[sortColumn];
        }
      
        if (valueA < valueB) return sortOrder === "asc" ? -1 : 1;
        if (valueA > valueB) return sortOrder === "asc" ? 1 : -1;
        return 0;
      });
      
      // Calculate grand total dynamically
      const grandTotal = useMemo(() => {
        return selectedProducts.reduce((total, row) => {
          const price = parseFloat(row.price.replace(/[₹,]/g, '')) || 0; // Convert price to number safely
          return total + price * row.quantity; // Accumulate total price
        }, 0);
      }, [selectedProducts]); // Recalculate whenever selectedProducts changes
      

      const totalProductPrice = (kitProducts?.kitProduct || []).reduce((sum, p) => {
        return sum + (parseFloat(p.price) * p.quantity); // Ensure price is numeric
      }, 0);

  // Fetch products from the backend API
  const fetchProducts = async (query) => {
    try {
      const response = await fetch(
        `${
          process.env.REACT_APP_JHS_DEVELOPMENT
        }/storepurchase/getsearchresult?search=${encodeURIComponent(query)}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch products");
      }
      const data = await response.json();
      // Function to sanitize strings by trimming and collapsing spaces

      const filteredData = data.filter((row) => {

        // if (!row.quantity || row.quantity <= 0) return false;
        const searchTerms = searchQuery
          .toLowerCase()
          .split(" ")
          .filter(Boolean); // Split on spaces and remove empty strings

        return searchTerms.every(
          (term) =>
            (row.product_id &&
              row.product_id.toString().toLowerCase().includes(term)) ||
            (row.product_name &&
              row.product_name.toLowerCase().includes(term)) ||
            (row.brand_name && row.brand_name.toLowerCase().includes(term)) ||
            (row.attribute_name &&
              row.attribute_name.toLowerCase().includes(term)) ||
            (row.attribute_value &&
              row.attribute_value.toLowerCase().includes(term)) ||
            (row.price && row.price.toString().toLowerCase().includes(term)) ||
            (row.quantity &&
              row.quantity.toString().toLowerCase().includes(term))
        );
      });

      setSearchResults(filteredData);
      console.log("Filtered Data:", filteredData);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const handleProductSelect = (product) => {
    setConfirmDelete(false);
    if (product.quantity === 0) {
      setSnackbarMessage("This product is out of stock.");
      setSnackbarMessageColor("error");
      setShowSnackbarMessage(true);
      return; // Stop execution if product is out of stock
    }
    let isAlreadySelected = false;
    setSelectedProducts((prev) => {
      if (!prev.some((p) => p.product_id === product.product_id)) {
        const updatedProducts = [
          { ...product, maxQuantity: product.quantity, quantity:1, product_quantity:product.quantity },
          ...prev
         // Preserve the original quantity as maxQuantity
        ];
        console.log("Updated Selected Products:", updatedProducts); // Debug: Check updated state
        return updatedProducts;
      }
      isAlreadySelected = true;
      return prev;
    });

       // Show snackbar **outside** of setSelectedProducts
  if (isAlreadySelected) {
    setSnackbarMessage("This product is already added to the kit.");
    setSnackbarMessageColor("error");
    setShowSnackbarMessage(true);
  }
    // Set selected quantity for this product as 1
  setSelectedQuantities((prev) => ({
    ...prev,
    [product.product_id]: 1,
  }));
    setSearchQuery("");
    setSearchResults([]);  
  }; 

   // Handle search input change
   const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    if (query.length > 0) {
      fetchProducts(query);
    } else {
      setSearchResults([]);
    }
    setSelectProductError("");
  };
  
  const openAddCategoryModal = (event) => {
    setisAddCategoryModal(true);
  };
 
  const handleClose = () => {
    setisAddCategoryModal(false);
    setOpenDelete(false);
    setDeletedRows([]);

    
    reset();
  };
  const handleCloseProducts = () => {
   setOpen(false)
  };
  const handleOpenConfirm =(kitId)=>{
    setOpenDeleteDialog(true);
    setIsReplicating(false);
    setKitId(kitId);
    
  }
  const handleCloseConfirm =()=>{
    setOpenDeleteDialog(false);
    setOpenBarcodeDialog(false);
    setSelectedNameToReplicate("");
    setSelectedDescriptionToReplicate("")
    setSelectedQuantityToReplicate("");
    setSelectedTotalPrice("");
    setKitProducts([]);
    setKitId(0);
  }


  const handleOpenConfirmReplicate = async (kitId, kitName, kitDescription, quantity, totalPrice)=>{
    setOpenDeleteDialog(true);
    setIsReplicating(true);
    
     try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/kits/getKitProduct",
        {
          method: "POST",
          credentials: "include",
          headers: { "Content-type": "application/json" },
          body: JSON.stringify({
            kit_id:kitId
          }),
        }
      );
      if (response.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin"); // Redirect if unauthorized
        return null; // Stop further execution
      }
      const data = await response.json();
      setKitProducts(data.kitProduct);
      setSelectedNameToReplicate(kitName + " (Copy)");
      setSelectedDescriptionToReplicate(kitDescription);
      setSelectedQuantityToReplicate(quantity);
      setSelectedTotalPrice(totalPrice);
      
    } catch (error) {
      console.error("Error fetching  details:", error);
    }
   
  }


const handleExport = (selectedKit) => {
  fetch(`${process.env.REACT_APP_JHS_DEVELOPMENT}/products/generateBarCode`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ productIds: selectedKit }), // Pass product IDs
  })
    .then((response) => {
      if (response.ok) {
        return response.blob();
      }
      throw new Error('Failed to export products');
    })
    .then((blob) => {
      // Create a URL for the blob
      const url = window.URL.createObjectURL(blob);

      // Create an anchor element to trigger the download
      const link = document.createElement('a');
      link.href = url;
      link.download = `barcodes_${new Date().toISOString().slice(0, 10)}.pdf`; // Name of the downloaded PDF file
      link.click(); // Trigger the download

      // Optionally, revoke the object URL after the download is triggered
      window.URL.revokeObjectURL(url);
      setSelectedProducts([]);
      setSelectedKit([]);
    })
    .catch((error) => {
      console.error('Error exporting products:', error);
      setOpenBarcodeDialog(true);
    });
  }
  useEffect(() => {
    const fetchUserData = async () => {
      const email = localStorage.getItem("user_email");
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/profiledata`,
          { email },
          { headers: { user_email: email } }
        );

        if (response.status === 200) {
          setUserId(response.data.user.user_id);
         
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchUserData();
  }, []);

useEffect(() => {
    getKits();
  }, []);



  const getKits = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/kits/getKits",
        {
          method: "GET",
          headers: { "Content-type": "application/json",credentials: "include", },
        }
      );
      const data = await response.json();
      if (response.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin"); // Redirect if unauthorized
        return null; // Stop further execution
      }
      setKits(data);
    } catch (error) {
      console.error("Error fetching  details:", error);
    }
  };
  const getKitProducts = async (kitId) => {
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/kits/getKitProduct",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          body: JSON.stringify({
            kit_id:kitId,
           
          }),
        }
      );
      const data = await response.json();
      setKitProducts(data);
      setOpen(true);
      
    } catch (error) {
      console.error("Error fetching  details:", error);
    }
  };

 const saveKit = async() => {
 if(!selectedNameToReplicate){
    let kitNameError = "";
    let selectProductError = "";
    let quantityError = "";
   
    // Validate Payment Date
    if (!kitName || kitName.trim() === "") {
      kitNameError = "Kit Name is required";
    }
    if (!selectedProducts || selectedProducts.length === 0) {
      selectProductError = "Product is required";
    }
   if (quantity < 0) {
      quantityError = "Quantity cannot be negative";
    }
    // Set errors and return if any validations fail
    if (
      kitNameError ||
      selectProductError||quantityError ) {
      setKitNameError(kitNameError);
      setSelectProductError(selectProductError);
      setQuantityError(quantityError);
  
      return; // Prevent form submission if there are errors
    }
  
    // // Reset error state after successful validation
    setKitNameError("");
    setSelectProductError("");
    setQuantityError("");
  }
   
    try {
      setIsLoading(true);
      // First API call: saveKit
      const saveKitResponse = await fetch(`${process.env.REACT_APP_JHS_DEVELOPMENT}/kits/saveKit`, {
        method: "POST",
        headers: { "Content-Type": "application/json",credentials: "include"},
        body: JSON.stringify({
          kit_name: selectedNameToReplicate ? selectedNameToReplicate: kitName.trim(),
          kit_description: selectedDescriptionToReplicate ? selectedDescriptionToReplicate:description.trim(),
          academic_year_id: academicYearId,
          // quantity:selectedQuantityToReplicate ? selectedQuantityToReplicate: quantity,
          quantity: quantity === "" ? 0 : selectedQuantityToReplicate ? selectedQuantityToReplicate : quantity,

          total_price:selectedTotalPrice ? selectedTotalPrice: grandTotal,
          created_by: userId,
         
        }),
      });

      if (saveKitResponse.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin"); // Redirect if unauthorized
        return null; // Stop further execution
      }
  
      if (!saveKitResponse.ok) {
        // throw new Error("Failed to save kit");
        setSnackbarMessage("A kit with this name already exists.");
        setSnackbarMessageColor("error");
        setShowSnackbarMessage(true);
      }
  
      const saveKitData = await saveKitResponse.json();
  
      // Extract kit_id
      const { createKit } = saveKitData;
      if (!createKit) {
        throw new Error("kit_id is missing in saveKit response");
      }
  
      // Second API call: saveKitAssociate
      const saveKitAssociateResponse = await fetch(`${process.env.REACT_APP_JHS_DEVELOPMENT}/kits/saveKitAssociate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          kit_id: createKit.kit_id, // Ensure correct extraction
          products:selectedNameToReplicate ? kitProducts:  selectedProducts, // Correct structure
          created_by: userId,
        }),
      });
      
  
      if (!saveKitAssociateResponse.ok) {
        throw new Error("Failed to associate kit");
      }
  
      const saveKitAssociateData = await saveKitAssociateResponse.json();
  
      handleResponse(saveKitAssociateData);
      setOpenDeleteDialog(false);
                setSelectedNameToReplicate("");
                setSelectedDescriptionToReplicate("")
                  setSelectedQuantityToReplicate("");
    setSelectedTotalPrice("");
                setKitProducts([]);
    }
     catch (error) {
      console.error("Error in saving kit and associating products:", error);
    }finally {
  setIsLoading(false); // Always stop loading regardless of success or failure
}
  };
  const deleteKit = async () => {
    fetch(process.env.REACT_APP_JHS_DEVELOPMENT + "/kits/deleteKit", {
      method: "POST",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify({
        kitIds: [kitId],
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        handleResponse(response);
        setOpenDeleteDialog(false)
      })
      .catch((error) => console.error("Error deleting fees slab:", error));
  };
  
  const handleResponse = (responseObject) => {
    if (responseObject.status === 200) {
      getKits();
      setisAddCategoryModal(false);
      setSnackbarMessage(responseObject.message);
      setSnackbarMessageColor("success");
      setShowSnackbarMessage(true);
      reset();

    }
    if (responseObject.status === 400) {
      setSnackbarMessage(responseObject.error);
      setSnackbarMessageColor("error");
      setShowSnackbarMessage(true);
    }
  };
  const reset = () => {
    setKitId();
    setKitName("");
    setDescription("");
    setQuantity(0);
    setSearchQuery("");
    setSelectedProducts([]);
    setSelectedQuantities({});
    setQuantityValidation({});

    setKitNameError("");
    setQuantityError("");
    setSelectProductError("");
    setSearchResults("");

    setisAddCategoryModal(false);
    setKitProducts([]);
    setDeletedRows([]);
    setConfirmDelete(false);
    
  };
//  const handleSave = () =>{
//   saveKit();

//  }
const handleSave = () => {
  let hasError = false;
  const updatedValidations = {};

  selectedProducts.forEach((product) => {
    const quantity = product.quantity;
    const maxQuantity = kitId ? product.product_quantity : product.maxQuantity;

    if (quantity === '' || quantity === undefined || quantity === null) {
      updatedValidations[product.product_id] = `Quantity is required and must be between 1 and ${maxQuantity}.`;
      hasError = true;
    } else if (Number(quantity) <= 0) {
      updatedValidations[product.product_id] = `Quantity must be greater than 0.`;
      hasError = true;
    } else if (Number(quantity) > maxQuantity) {
      updatedValidations[product.product_id] = `Quantity cannot exceed available stock (${maxQuantity}).`;
      hasError = true;
    }
  });

  setQuantityValidation(updatedValidations);

  if (!hasError) {
    saveKit();
  }
};

const handleUpdate = () => {
  let hasError = false;
  const updatedValidations = {};

  selectedProducts.forEach((product) => {
    const quantity = product.quantity;
    const maxQuantity = kitId ? product.product_quantity : product.maxQuantity;

    if (quantity === '' || quantity === undefined || quantity === null) {
      updatedValidations[product.product_id] = `Quantity is required and must be between 1 and ${maxQuantity}.`;
      hasError = true;
    } else if (Number(quantity) <= 0) {
      updatedValidations[product.product_id] = `Quantity must be greater than 0.`;
      hasError = true;
    } else if (Number(quantity) > maxQuantity) {
      updatedValidations[product.product_id] = `Quantity cannot exceed available stock (${maxQuantity}).`;
      hasError = true;
    }
  });

  setQuantityValidation(updatedValidations);

  if (!hasError) {
    editKit();
  }
};


 const handleQuantityChange = (e, productId) => {
  const inputValue = e.target.value; // Keep as string initially
 

  setSelectedProducts((prevProducts) => {
    return prevProducts.map((product) => {
      if (product.product_id === productId) {
        const maxQuantity = kitId ? product.product_quantity : product.maxQuantity;

        // If input is empty
        if (inputValue === '') {
          setQuantityValidation((prev) => ({
            ...prev,
            [productId]: `Quantity is required and must be between 1 and ${maxQuantity}.`,
          }));

          return { ...product, quantity: '' };
        }

        const parsedValue = Number(inputValue);

        // If input is not a valid number (NaN)
        if (isNaN(parsedValue)) {
          setQuantityValidation((prev) => ({
            ...prev,
            [productId]: `Invalid quantity entered.`,
          }));
          return { ...product, quantity: '' };
        }

        // If input is negative or zero
        if (parsedValue <= 0) {
          setQuantityValidation((prev) => ({
            ...prev,
            [productId]: `Quantity must be greater than 0.`,
          }));

          return { ...product, quantity: parsedValue };
        }

        // If input is greater than stock
        if (parsedValue > maxQuantity) {
          setQuantityValidation((prev) => ({
            ...prev,
            [productId]: `Quantity cannot exceed available stock (${maxQuantity}).`,
          }));

          return { ...product, quantity: parsedValue };
        }

        // If input is valid
        setQuantityValidation((prev) => {
          const updatedValidation = { ...prev };
          delete updatedValidation[productId];
          return updatedValidation;
        });

        setSelectedQuantities((prev) => ({
          ...prev,
          [productId]: parsedValue,
        }));

        return { ...product, quantity: parsedValue };
      }
      return product;
    });
  });
};
const handleSelectCheckBox = (row) => {
  setSelectedKit((prevSelected) => {
    if (prevSelected.includes(row.kit_id)) {
      return prevSelected.filter((id) => id !== row.kit_id); // Deselect
    } else {
      return [...prevSelected, row.kit_id]; // Select
    }
  });
};


const editKit = async() => {
  if(!selectedNameToReplicate){
     let kitNameError = "";
     let selectProductError = "";
     let quantityError = "";
    
     // Validate Payment Date
     if (!kitName || kitName.trim() === "") {
       kitNameError = "Kit Name is required";
     }
     if (!selectedProducts || selectedProducts.length === 0) {
       selectProductError = "Product is required";
     }
    if (quantity < 0) {
      quantityError = "Quantity cannot be negative";
    }
     // Set errors and return if any validations fail
     if (
       kitNameError ||
       selectProductError||quantityError ) {
       setKitNameError(kitNameError);
       setSelectProductError(selectProductError);
       setQuantityError(quantityError);
   
       return; // Prevent form submission if there are errors
     }
   
     // // Reset error state after successful validation
     setKitNameError("");
     setSelectProductError("");
     setQuantityError("");
   }
    
     try {
       // First API call: saveKit
       const editKitResponse = await fetch(`${process.env.REACT_APP_JHS_DEVELOPMENT}/kits/editKit`, {
         method: "POST",
         headers: { "Content-Type": "application/json",credentials: "include", },
         body: JSON.stringify({
           kit_id:kitId,
           kit_name: selectedNameToReplicate ? selectedNameToReplicate: kitName.trim(),
           kit_description: selectedDescriptionToReplicate ? selectedDescriptionToReplicate:description.trim(),
          //  quantity:selectedQuantityToReplicate ? selectedQuantityToReplicate: quantity,
          quantity: quantity === "" ? 0 : selectedQuantityToReplicate ? selectedQuantityToReplicate : quantity,
           total_price:selectedTotalPrice ? selectedTotalPrice: grandTotal,
           academic_year_id: academicYearId,
           updated_by: userId,
           updated_timestamp: new Date(),
         
         }),
       });
       if (editKitResponse.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin"); // Redirect if unauthorized
        return null; // Stop further execution
      }
       if (!editKitResponse.ok) {
        // throw new Error("Failed to save kit");
        setSnackbarMessage("A kit with this name already exists.");
        setSnackbarMessageColor("error");
        setShowSnackbarMessage(true);
        return;
      }
      
       // Second API call: saveKitAssociate
       const saveKitAssociateResponse = await fetch(`${process.env.REACT_APP_JHS_DEVELOPMENT}/kits/editKitAssociate`, {
         method: "POST",
         headers: { "Content-Type": "application/json" },
         body: JSON.stringify({
           kit_id:kitId, 
           products:selectedProducts, 
           updated_by: userId,
           updated_timestamp: new Date(),
         }),
       });
   
       if (!saveKitAssociateResponse.ok) {
         throw new Error("Failed to associate kit");
       }
   
       const saveKitAssociateData = await saveKitAssociateResponse.json();
   
       handleResponse(saveKitAssociateData);
       setOpenDeleteDialog(false);
       setSelectedNameToReplicate("");
       setSelectedDescriptionToReplicate("");
         setSelectedQuantityToReplicate("");
    setSelectedTotalPrice("");
       setKitProducts([]);
     } catch (error) {
       console.error("Error in saving kit and associating products:", error);
     }


// if(deletedRows.length > 0){
if(confirmDelete){
     try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/kits/deleteKitProducts",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            kit_id: kitId,
            deletedRows: deletedRows,
          }),
        }
      );
    } catch (error) {
      console.error("Error fetching details:", error);
    }
   };
  }
  // }


  // pagination and sorting
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Sorting function
  const handleRequestSort = (property) => {
    const isAscending = orderBy === property && order === "asc";
    setOrder(isAscending ? "desc" : "asc");
    setOrderBy(property);
  };
  const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  };
 useEffect(() => {
    // Reset to default sorting when students are fetched
    setOrder("desc");
    setOrderBy("kit_id");
  }, [kits]);

  const getComparator = (order, orderBy) => {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  };
  const filteredRows = kits.filter((row) => {
    const searchTerms = search.toLowerCase().split(" ").filter(Boolean); // Split on spaces and remove empty strings

    return searchTerms.every(
      (term) =>
        (row.kit_id &&row.kit_id.toString().toLowerCase().includes(term)) ||
        (row.kit_name && row.kit_name.toLowerCase().includes(term)) ||
        (row.kit_description && row.kit_description.toLowerCase().includes(term))||
        (row.quantity &&row.quantity.toString().toLowerCase().includes(term)) ||
        (row.total_price &&row.total_price.toString().toLowerCase().includes(term))
        
    );
  });
 

  // Sort the rows before displaying them
  const sortedRows = filteredRows
    .map((row, index) => ({ ...row, index: index + 1 })) // Add index for Serial No.
    .sort(getComparator(order, orderBy));

    
  const handleSelectRow =async (
    kitId,
    kitName,
    description,
    quantity
  ) => {
    setisAddCategoryModal(true);
   setKitId(kitId);
   setKitName(kitName);
   setDescription(description);
   setQuantity(quantity);
  try {
    const response = await fetch(
      process.env.REACT_APP_JHS_DEVELOPMENT + "/kits/getKitProduct",
      {
        method: "POST",
        headers: { "Content-type": "application/json" },
        body: JSON.stringify({
          kit_id:kitId,
         
        }),
      }
    );
    const data = await response.json();
       // Ensure maxQuantity is preserved for editing purposes
       const updatedProducts = data.kitProduct.map((product) => ({
        ...product,
        maxQuantity: product.quantity, // Store original quantity
      }));
    setSelectedProducts(updatedProducts)
    
  } catch (error) {
    console.error("Error fetching  details:", error);
  }
  
  };
 

  return (
    <>
      <Layout />
      <h1 className="title">Create Kit</h1>


<Dialog
        onClose={handleClose}
        open={isAddCategoryModal}
        maxWidth='100%'
        fullWidth
        // sx={{
        //   "& .MuiDialog-paper": {
        //     width: "450%", // Adjust width
        //     height: "85%", // Adjust height
        //     maxWidth: "90%", // Optional, to make it responsive
        //     borderRadius:'2'
        //   },
        // }}
      >
        <DialogTitle
          alignSelf={"left"}
          style={{
            paddingBottom: "0",
            marginLeft: "9px",
            marginRight: "6px",
            marginTop:"10px",
            color: "#0A64A2",
          }}
        >
        {kitId? <img 
                  src={kitEditIcon} 
                  alt="Product Icon" 
                  style={{ 
                    marginRight: '0.2px', 
                    height: '30px',
                    color: '#0A64A2',
                    right:'3px',
                    position: 'relative',
                    top: '0.2em',
                    paddingRight:'2px'
                  }} 
                />: 
           <img 
                  src={kitAddIcon} 
                  alt="Product Icon" 
                  style={{ 
                    marginRight: '0.2px', 
                    height: '30px',
                    color: '#0A64A2',
                    right:'3px',
                    position: 'relative',
                    top: '0.2em',
                    paddingRight:'2px'
                  }} 
                />}{kitId ? "Edit Kit" : "Add Kit"}
          {/* <span style={{ display: "block", borderBottom: "2px solid #0A64A2", width: "62em", marginTop: "0px",marginBottom:'0px' }}/> */}
        <Divider
          className="divider"
          style={{ width: "100%", marginLeft: "0px" }}
        />
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          size="small"
          sx={{
            position: "absolute",
            right: 8,
            top: 2,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent style={{ paddingTop: "10px" }}>
          <Stack padding={1}>
  
<Stack spacing={2} direction="row">
        <Stack spacing={1} direction="column" className="form-stack">
        <TextField
             id="outlined-basic"
             value={kitName}
             name="kitName"
             onChange={(event) => {
               const value = event.target.value;
               setKitName(value);
               setKitNameError("");
             }}
             size="small"
             label={kitNameError ? kitNameError : "Kit Name"}
             error={!!kitNameError}
             variant="outlined"
             required
              
            >
             
            </TextField>

           <TextField
            id="outlined-basic"
            value={description}
            onChange={(event) => {
              setDescription(event.target.value);
            }}
            size="small"
            multiline
            rows={2}
            label="Kit Description"
            variant="outlined"
            inputProps={{ maxLength: 250 }}
            style={{ width: "207%" }}
          /> 

        </Stack>

        <Stack spacing={1} direction="column">
         
           <TextField
            id="outlined-basic"
            value={quantity}
            name="quantity"
            onChange={(event) => {
              const value = event.target.value;
              setQuantity(value);
              // setQuantityError("");

              // Check if the entered value is less than or equal to 0
    if (value < 0) {
      setQuantityError("Quantity cannot be negative");
    } else {
      setQuantityError("");
    }
            }}
            size="small"
            type="number"
            variant="outlined"
            label={quantityError ? quantityError : "Kit Quantity"}
            error={!!quantityError}
            inputProps={{ min: 0 }}
          
            
          
            >
        
    </TextField>
          
        </Stack>
      </Stack>
   
      
     
    <div className="create_search">
        {/* Search Field and Proceed Button */}
        <div style={{ display: "flex" }}>
          <div className="create_search1">
          <TextField
           sx={{ minWidth: 700, marginBottom: "4px", marginTop: "30px" }}
        id="outlined-basic"
        name="selectProduct"
        size="small"
        variant="outlined"
        required
        value={searchQuery}
        onChange={handleSearchChange}
        label={selectProductError ? selectProductError : "Search Product"}
        error={!!selectProductError}
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <IconButton
                type="button"
                sx={{ p: "0px" }}
                aria-label="search" 
              >
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
          </div>
          <div className="sale-div-kit">
            <div className="sale-delete-div">
              <Button
                variant="contained"
                color="primary"
                disabled={isLoading}
                onClick={kitId? handleUpdate:handleSave}
                className="save_update_btn"
              >
                 {/* {kitId ? "Update" : "Save"} */}
                   {isLoading ? "Saving..." : kitId ? "Update" : "Save"}
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleDeleteProduct}
                className="sale-delete-btn"
              >
                Delete
              </Button>
            </div>
          </div>
        </div>

        {/* Search Results List */}
        {searchResults.length > 0 && (
          <List
            sx={{
              border: "1px solid #ccc",
              borderRadius: "4px",
              padding: "0",
              width: 700,
            }}
          >
            {searchResults.map((product) => (
              <ListItem
                button
                key={product.id}
                onClick={() => handleProductSelect(product)}
              >
                <ListItemText primary={product.product_name} />
                <ListItemText primary={product.attribute_name} />
                <ListItemText primary={product.attribute_value} />
                <ListItemText primary={product.price} />
                <ListItemText primary={product.quantity} />
              </ListItem>
            ))}
          </List>
        )}
      </div>

      
<TableContainer component={Paper}>
  <Table sx={{ minWidth: 750 }} aria-label="customized table">
    <TableHead>
      <TableRow>
      <StyledTableCell><TableSortLabel
            active={sortColumn === "sl_no"}
            direction={sortColumn === "sl_no" ? sortOrder : "asc"}
            onClick={() => handleSort("sl_no")}
          >
            Sl.No
          </TableSortLabel></StyledTableCell>
        <StyledTableCell style={{padding:'0'}}><TableSortLabel
            active={sortColumn === "product_id"}
            direction={sortColumn === "product_id" ? sortOrder : "asc"}
            onClick={() => handleSort("product_id")}
          >
            Product Id
          </TableSortLabel></StyledTableCell>

        {/* Sortable Column - Product Name */}
        <StyledTableCell align="center" style={{padding:'0'}}>
          <TableSortLabel style={{margin:'0'}}
            active={sortColumn === "product_name"}
            direction={sortColumn === "product_name" ? sortOrder : "asc"}
            onClick={() => handleSort("product_name")}
          >
            Product Name
          </TableSortLabel>
        </StyledTableCell>

        {/* Sortable Column - Attribute Name */}
        <StyledTableCell align="center" style={{padding:'0'}}>
          <TableSortLabel style={{margin:'0'}}
            active={sortColumn === "attribute_name"}
            direction={sortColumn === "attribute_name" ? sortOrder : "asc"}
            onClick={() => handleSort("attribute_name")}
          >
            Attribute Name
          </TableSortLabel>
        </StyledTableCell>

        <StyledTableCell align="center" style={{padding:'0'}}>
          <TableSortLabel style={{margin:'0'}}
            active={sortColumn === "attribute_value"}
            direction={sortColumn === "attribute_value" ? sortOrder : "asc"}
            onClick={() => handleSort("attribute_value")}
          >
            Attribute Value
          </TableSortLabel>
        </StyledTableCell>

        {/* Sortable Column - Price */}
        <StyledTableCell align="center">
          <TableSortLabel
            active={sortColumn === "price"}
            direction={sortColumn === "price" ? sortOrder : "asc"}
            onClick={() => handleSort("price")}
          >
            Price
          </TableSortLabel>
        </StyledTableCell>

        {/* Sortable Column - Quantity */}
        <StyledTableCell align="center">
          <TableSortLabel
            active={sortColumn === "quantity"}
            direction={sortColumn === "quantity" ? sortOrder : "asc"}
            onClick={() => handleSort("quantity")}
          >
            Quantity
          </TableSortLabel>
        </StyledTableCell>
       
       
        <StyledTableCell align="center" style={{padding:'0'}}>
          <TableSortLabel style={{margin:'0'}}
            active={sortColumn === "product_quantity"}
            direction={sortColumn === "product_quantity" ? sortOrder : "asc"}
            onClick={() => handleSort("product_quantity")}
          >
            Available Stock
          </TableSortLabel>
        </StyledTableCell>
        {/* Sortable Column - Total Price */}
        <StyledTableCell align="center">
          <TableSortLabel
            active={sortColumn === "total_price"}
            direction={sortColumn === "total_price" ? sortOrder : "asc"}
            onClick={() => handleSort("total_price")}
          >
            Total Price
          </TableSortLabel>
        </StyledTableCell>
        <StyledTableCell align="center"></StyledTableCell>
      </TableRow>
    </TableHead>
    
    <TableBody>
      {sortedProducts.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (

        <StyledTableRow
  key={row.product_id}
  style={{
    backgroundColor: deletedRows.some((item) => item.product_id === row.product_id)
      ? "rgba(243, 233, 233, 0.1)"
      : "transparent", // Light red background
    position: "relative",
  }}
>
<StyledTableCell align="center">
{getSerialNumber(index)}
    {deletedRows.some((item) => item.product_id === row.product_id) && (
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: 0,
          width: "95%",
          height: "2px",
          backgroundColor: "red",
          transform: "translateY(-50%)",
        }}
      />
    )}
  </StyledTableCell>
  <StyledTableCell align="center">
    {row.product_id}
    {deletedRows.some((item) => item.product_id === row.product_id) && (
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: 0,
          width: "95%",
          height: "2px",
          backgroundColor: "red",
          transform: "translateY(-50%)",
        }}
      />
    )}
  </StyledTableCell>

  <StyledTableCell align="center">
    {row.product_name}
    {deletedRows.some((item) => item.product_id === row.product_id) && (
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: 0,
          width: "95%",
          height: "2px",
          backgroundColor: "red",
          transform: "translateY(-50%)",
        }}
      />
    )}
  </StyledTableCell>

  <StyledTableCell align="center">
    {row.attribute_name}
    {deletedRows.some((item) => item.product_id === row.product_id) && (
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: 0,
          width: "95%",
          height: "2px",
          backgroundColor: "red",
          transform: "translateY(-50%)",
        }}
      />
    )}
  </StyledTableCell>

  <StyledTableCell align="center">
    {row.attribute_value}
    {deletedRows.some((item) => item.product_id === row.product_id) && (
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: 0,
          width: "95%",
          height: "2px",
          backgroundColor: "red",
          transform: "translateY(-50%)",
        }}
      />
    )}
  </StyledTableCell>

  <StyledTableCell align="center">
    {parseFloat(row.price.replace(/[₹,]/g, '')) }
    {deletedRows.some((item) => item.product_id === row.product_id) && (
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: 0,
          width: "95%",
          height: "2px",
          backgroundColor: "red",
          transform: "translateY(-50%)",
        }}
      />
    )}
  </StyledTableCell>

  <StyledTableCell align="center" className="table-cell-border">
    {deletedRows.some((item) => item.product_id === row.product_id) && (
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: 0,
          width: "100%",
          height: "2px",
          backgroundColor: "red",
          transform: "translateY(-50%)",
        }}
      />
    )}
    <div>
      <input
        type="number"
        // value={row.quantity}
        value={row.quantity === '' ? '' : row.quantity}
        onChange={(e) => handleQuantityChange(e, row.product_id)}
        style={{ width: "60px" }}
      />
      {quantityValidation[row.product_id] && (
        <div style={{ color: "red", marginTop: "5px" }}>
          {quantityValidation[row.product_id]}
        </div>
      )}
    </div>
  </StyledTableCell>

  <StyledTableCell align="center">
    {/* {row.price} */}
    {row.product_quantity}
    {deletedRows.some((item) => item.product_id === row.product_id) && (
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: 0,
          width: "95%",
          height: "2px",
          backgroundColor: "red",
          transform: "translateY(-50%)",
        }}
      />
    )}
  </StyledTableCell>

  <StyledTableCell align="center">
    {parseFloat(row.price.replace(/[₹,]/g, '')) * row.quantity}
  </StyledTableCell>

  <StyledTableCell align="center" style={{ lineHeight: "10px", padding: "5px" }}>
    <IconButton
      color="black"
      onClick={() => handleToggleDelete(row.product_id, row.quantity)}
    >
      <DeleteIcon />
    </IconButton>
  </StyledTableCell>
</StyledTableRow>

      ))}
<TableRow>
                    <TableCell
                      colSpan={10}
                      align="right"
                      sx={{
                        fontWeight: "bold",
                        fontSize: "0.9rem",
                        color: "#695a5a",
                        padding: "13px",
                        paddingRight: "70px",
                      }}
                    >
                      Grand Total: {grandTotal.toFixed(2)}
                    </TableCell>
                  </TableRow>
                </TableBody>
  </Table>
</TableContainer>

    

            <TablePagination
              style={{ backgroundColor: "#0A64A2", color: "#fff" }}
              rowsPerPageOptions={[5, 10, 15]}
              component="div"
              count={selectedProducts.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />

         
            
          </Stack>
        </DialogContent>
      </Dialog>
       


      <Container>
        <div className="product_container">
          <div style={{ display: "flex" }}>
            <TextField
              sx={{ minWidth: 300, mt: 0, mb: 0, pt: 0, pb:0 }}
              label="Search..."
              variant="outlined"
              fullWidth
              value={search}
              onChange={(event) => {
                setSearch(event.target.value);
                setPage(0);
              }}
              size="small"
              style={{ marginBottom: "0", border: "none" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton type="button" aria-label="search">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div className="user_mngmt_add_delete_container">
            <Button
              className="generate_barcode_btn"
              variant="contained"
              onClick={() => handleExport(selectedKit)}
            >
              Generate Barcode
            </Button>

            <Button
              
              style={{backgroundColor:'#0A64A2', color:'white'}}
              onClick={() => openAddCategoryModal(true)}
            >
              Add Kit
            </Button>
          </div>
        </div>
        {/* {error && <p style={{ color: "red" }}>{error}</p>} */}

        <Box className="table-container">
          <Paper className="table-paper">
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 750 }}>
              <TableHead align="center">
                  <TableRow>
                    <StyledTableCell
                      sortDirection={orderBy === "kit_id" ? order : false}
                      align="center"
                      className="fees_report_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "kit_id"}
                        direction={orderBy === "kit_id" ? order : "asc"}
                        onClick={() => handleRequestSort("kit_id")}
                      >
                        Kit ID
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      sortDirection={orderBy === "kit_name" ? order : false}
                      align="center"
                      className="fees_report_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "kit_name"}
                        direction={orderBy === "kit_name" ? order : "asc"}
                        onClick={() => handleRequestSort("kit_name")}
                      >
                        Kit Name
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ paddingLeft: "28px" }}
                    >
                      <TableSortLabel
                        active={orderBy === "kit_description"}
                        direction={orderBy === "kit_description" ? order : "asc"}
                        onClick={() => handleRequestSort("kit_description")}
                      > 
                        Description
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ paddingLeft: "28px" }}
                    >
                      <TableSortLabel
                        active={orderBy === "quantity"}
                        direction={orderBy === "quantity" ? order : "asc"}
                        onClick={() => handleRequestSort("quantity")}
                      > 
                        Quantity
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ paddingLeft: "28px" }}
                    >
                      <TableSortLabel
                        active={orderBy === "total_price"}
                        direction={orderBy === "total_price" ? order : "asc"}
                        onClick={() => handleRequestSort("total_price")}
                      > 
                        Total Price
                      </TableSortLabel>
                    </StyledTableCell>
                    
                    <StyledTableCell  align="center">Products </StyledTableCell>
                   
                    <StyledTableCell align="center" > Replicate Kit </StyledTableCell>
                    <StyledTableCell
                      align="center" > Barcode  </StyledTableCell>
                    <StyledTableCell align="center"> </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
  {(rowsPerPage > 0
    ? sortedRows.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      )
    : sortedRows
  ).map((row, i) => (
    <StyledTableRow
      key={row.kit}
      style={{ cursor: "pointer" }}
      
    >
      <StyledTableCell align="center"onClick={() => { handleSelectRow( row.kit_id,row.kit_name,row.kit_description, row.quantity,row.total_price)}}> {row.kit_id}</StyledTableCell>
      <StyledTableCell align="center"onClick={() => { handleSelectRow( row.kit_id,row.kit_name,row.kit_description, row.quantity,row.total_price)}}>{row.kit_name}</StyledTableCell>
      <StyledTableCell align="center"onClick={() => { handleSelectRow( row.kit_id,row.kit_name,row.kit_description, row.quantity,row.total_price)}}>{row.kit_description}</StyledTableCell>
      <StyledTableCell align="center"onClick={() => { handleSelectRow( row.kit_id,row.kit_name,row.kit_description, row.quantity,row.total_price)}}>{row.quantity}</StyledTableCell>
      <StyledTableCell align="center"onClick={() => { handleSelectRow( row.kit_id,row.kit_name,row.kit_description, row.quantity,row.total_price)}}>{row.total_price}</StyledTableCell>
     <StyledTableCell align="center">
     <IconButton
     color="black"
     sx={{padding:'0', color:'rgb(10, 100, 162)'}}
     onClick={() => getKitProducts(row.kit_id)}
   >
     <ListAltIcon/>
   </IconButton>
     </StyledTableCell>
     
   

      <StyledTableCell
      align="center"
      style={{
      padding: "0",
      marginLeft: "0",
      paddingRight: "0px",
      }}>


     <IconButton
     color="black"
     onClick={() => handleOpenConfirmReplicate(row.kit_id, row.kit_name, row.kit_description, row.quantity, row.total_price)}
   >
     <ContentCopyIcon/>
   </IconButton>
   </StyledTableCell>
   <StyledTableCell
        align="center"
        style={{
          padding: "0",
          marginLeft: "0",
          paddingRight: "0px",
        }}
      >
        <Checkbox
          checked={selectedKit.includes(row.kit_id)} // Checked if selected
          onChange={(event) => {
            event.stopPropagation(); // Prevent row click from firing
            handleSelectCheckBox(row); // Toggle selection
          }}
        />
      </StyledTableCell>

   <StyledTableCell
align="center"
style={{
  padding: "0",
  marginLeft: "0",
  paddingRight: "0px",
}}>


     <IconButton
     color="black"
     onClick={() => handleOpenConfirm(row.kit_id)}
   >
     <DeleteIcon />
   </IconButton>
   </StyledTableCell>
   </StyledTableRow>
    
    
  ))}
</TableBody>

                <TableFooter>
                  <TableRow>
                    <TablePagination
                      sx={{
                        backgroundColor: "#0A64A2",
                        color: "white",
                        width: "100%",
                      }}
                      rowsPerPageOptions={[5, 10, 25]}
                      colSpan={9}
                      count={sortedRows.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      </Container>

      <Snackbar
        open={showSnackbarMessage}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={() => {
          setShowSnackbarMessage(false);
        }}
        message={snackbarMessage}
      >
        <Alert
          severity={snackbarMessageColor}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>


{/* Product List Dialog */}
<Dialog
                            open={open}
                            onClose={handleCloseProducts}
                            maxWidth="lg"
                            fullWidth={false}
                            PaperProps={{
                              style: {
                                maxHeight: "90vh",
                                boxShadow: "0",
                              },
                            }}
                            BackdropProps={{
                              style: {
                                backgroundColor: "rgba(0, 0, 0, 0.2)",
                              },
                            }}
                          >
                            <IconButton
                              onClick={handleCloseProducts}
                              style={{
                                color: "#817575",
                                position: "absolute",
                                right: "4px",
                              }}
                            >
                              <CloseIcon />
                            </IconButton>
                            <Box>
                              <DialogTitle
                                style={{
                                  color: "#0A64A2",
                                  padding: "0px 11px", // Adjust padding for a more compact look
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginBottom: "0",
                                  marginTop: "15px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <ListAltIcon style={{ paddingBottom: "0", marginTop: "7px", }}
                                  />
                                  <span
                                    style={{
                                      marginLeft: "4px",
                                      fontWeight: "bold",
                                      fontSize: "18px",
                                      marginTop: "10px",
                                    }}
                                  >
                                    Product List
                                  </span>
                                </div>
                              </DialogTitle>
                            </Box>
                            <Divider
                              className="divider"
                              style={{ width: "94%", marginLeft: "13px" }}
                            />
                            <DialogContent
                              style={{ padding: "0", margin: "0px 10px" }}
                            >
                             
                                  <div
                                    // key={type}
                                    style={{ marginBottom: "4px" }}
                                  >
                                   
                                    <Table size="small">
                                      <TableHead>
                                        <TableRow>
                                        <TableCell style={{ color: "#0A64A2",  padding: "4px", }} > Sl.No</TableCell>
                                          <TableCell style={{ color: "#0A64A2",  padding: "4px", }}
                                          > Product Name </TableCell>
                                          <TableCell style={{color: "#0A64A2", padding: "4px",}}
                                          >Attribute </TableCell>
                                         
                                          <TableCell style={{color: "#0A64A2",  padding: "4px", }}
                                          >Quantity </TableCell>
                                          <TableCell style={{color: "#0A64A2",  padding: "4px",}}
                                          > Price
                                          </TableCell>
                                          <TableCell style={{color: "#0A64A2", padding: "4px", }}
                                          > Total Price </TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {(kitProducts?.kitProduct||[]).map((p,index) => (
                                          <TableRow key={p.product_id}>
                                            <TableCell className="table-cell-product-list">{index + 1}</TableCell>
                                            <TableCell align="left"style={{ padding: "4px" }}
                                            > {p.product_name}
                                            </TableCell>
                                            <TableCell align="left" style={{ padding: "4px" }}
                                            >{p.attribute_name} : {p.attribute_value}
                                            </TableCell>
                                           
                                            <TableCell align="center" style={{ paddingLeft: "4px" }}
                                            >{p.quantity}
                                            </TableCell>
                                            <TableCell align="center" style={{ padding: "4px" }}
                                            > {p.price}
                                            </TableCell>
                                            <TableCell align="center" style={{ padding: "4px" }}
                                            > {p.price * p.quantity}</TableCell>
                                          </TableRow>
                                        ))}
                                      </TableBody>
                                    </Table>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "end",
                                        marginRight: "10px",
                                        fontWeight: "bold",
                                        fontSize: "0.9rem",
                                        marginTop: "5px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          color:  "#0A64A2",
                                        }}
                                      >
                                        Total Price:
                                      </span>
                                      &nbsp;
                                      <span
                                        style={{ color: "rgb(58 48 48 / 87%)" }}
                                      >
                                        {totalProductPrice.toFixed(2)}
                                      </span>
                                    </div>
                                  </div>
                              
                              

                              {/* Calculate total amounts for both issued and refunded products */}
                            

                    
                            </DialogContent>
                          </Dialog>
  {/* Delete Confirmation Dialog */}
  <Dialog
        open={openDeleteDialog}
        onClose={handleCloseConfirm}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px",borderRadius:"5px" }, // Set the width to 300px
        }}
      >
        <DialogContent style={{ paddingLeft: "15px" }}>
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }} // Center align text
          >
            {isReplicating ? " Do you want to replicate this kit?" : "Are you sure you want to delete this Kit?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          {" "}
          {/* Center-align the buttons */}
          <Button
          variant="contained"
          onClick={isReplicating? saveKit : deleteKit}
          className="no-btn"
          >
            Yes
          </Button>
          <Button
          variant="contained"
            onClick={handleCloseConfirm}
            autoFocus
            className="no-btn"
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
{/* for barcode */}
<Dialog
        open={openBarcodeDialog}
        onClose={handleCloseConfirm}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px",borderRadius:"5px" }, // Set the width to 300px
        }}
      >
        <DialogContent style={{ paddingLeft: "15px" }}>
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }} // Center align text
          >
            Kindly select the kit(s) to generate barcode.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
       
          <Button
          variant="contained"
            onClick={handleCloseConfirm}
            autoFocus
            className="no-btn"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>


      
                {/* Delete Confirmation Dialog */}
      
            <Dialog
              open={openDelete}
              onClose={handleCancelDelete}
              aria-labelledby="delete-dialog-title"
              aria-describedby="delete-dialog-description"
              PaperProps={{
                sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" }, // Set the width to 300px
              }}
            >
              <DialogContent style={{ paddingLeft: "15px" }}>
                <DialogContentText
                  id="delete-dialog-description"
                  style={{ fontSize: "1.1em", color: "#0A64A2" }} // Center align text
                >
                  {deletedRows.length > 0
                    ? "Are you sure you want to delete this selected Product(s)?"
                    : "Please select product before deleting."}
                </DialogContentText>
              </DialogContent>
              <DialogActions sx={{ justifyContent: "flex-end" }}>
                {" "}
                {/* Center-align the buttons */}
                {deletedRows.length > 0 ? (
                  <Button
                    variant="contained"
                    onClick={handleDeleteConfirm}
                    className="no-btn"
                  >
                    Yes
                  </Button>
                ) : (
                  ""
                )}
                <Button
                  variant="contained"
                  onClick={handleCancelDelete}
                  autoFocus
                  className="no-btn"
                >
                  {deletedRows.length > 0 ? "No" : "Ok"}
                </Button>
              </DialogActions>
            </Dialog>
      

    </>
  );
}
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A64A2",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const Container = styled("div")({
  padding: "5rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
});



